import React from "react";

export default function Library(props){
    return(
        <div id="library">
            <h1>Library</h1>
            <div>
                <span>Liked Music</span>
                <span>Artist</span>
            </div>
        </div>
    )
}